module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_16_3.8b122c2c.jpeg";